module.exports = __webpack_public_path__ + "img/Lab Book Icon_Down.5fa64ad7.svg";